import { render } from "./WatchlistEdit.vue?vue&type=template&id=5f2b01e5&ts=true"
import script from "./WatchlistEdit.vue?vue&type=script&lang=ts"
export * from "./WatchlistEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__